import BaseFormComponent from '../abstracts/BaseFormComponent';

export default class TextSearchComponent extends BaseFormComponent {
  constructor(element) {
    super(element);
    this.handleSubmit();
  }

  handleSubmit() {
    this.onSubmit((e, action, formButton) => {
      const formData = this.serializeForm(this.$el).getData('object');
      window.location.assign(`${action}?q=${formData.searchQuery}`);
    });
  }
}
